import React from 'react';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    className?: string;
    /** Focus target for step-change focus management; pair with headingTabIndex={-1}. */
    headingRef?: React.Ref<HTMLHeadingElement>;
    headingTabIndex?: number;
}

// The ring can only paint once headingTabIndex makes the h1 focusable, so it stays inert for
// callers that omit it. brand-600/400 rather than the inputs' brand-500/10, which is only
// visible there because it is paired with a border colour change.
const HEADING_CLASSES =
    'text-2xl font-semibold text-mp-foreground focus-visible:outline-hidden focus-visible:ring-3 focus-visible:ring-mp-primary';

export const PageHeader: React.FC<PageHeaderProps> = ({
    title,
    subtitle,
    className = 'space-y-4',
    headingRef,
    headingTabIndex,
}) => {
    return (
        <div className={className}>
            <h1 ref={headingRef} tabIndex={headingTabIndex} className={HEADING_CLASSES}>
                {title}
            </h1>
            {subtitle && <p className="text-mp-foreground">{subtitle}</p>}
        </div>
    );
};
